/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u3m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three minutes is long enough to require real conditioning and force fighters to pace themselves, but short enough to allow multiple rounds with recovery time between them. It's been the standard round length in professional boxing for over a century.`)
};

const es_timer_u3m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tres minutos son suficientes para exigir una condición física real y obligar a los boxeadores a dosificar su esfuerzo, pero lo bastante cortos para permitir varios rounds con tiempo de recuperación entre ellos. Ha sido la duración estándar del round en el boxeo profesional durante más de un siglo.`)
};

const de_timer_u3m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drei Minuten sind lang genug, um echte Kondition zu erfordern und Boxer zum Einteilen ihrer Kräfte zu zwingen, aber kurz genug, um mehrere Runden mit Erholungszeit dazwischen zu ermöglichen. Es ist seit über einem Jahrhundert die Standard-Rundenlänge im Profiboxen.`)
};

const nl_timer_u3m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drie minuten is lang genoeg om echte conditie te vereisen en vechters te dwingen hun tempo te bewaken, maar kort genoeg om meerdere rondes met hersteltijd ertussen mogelijk te maken. Het is al meer dan een eeuw de standaard rondelengte in het professionele boksen.`)
};

const fr_timer_u3m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trois minutes, c’est assez long pour exiger une réelle condition physique et forcer les boxeurs à gérer leur effort, mais assez court pour permettre plusieurs rounds avec du temps de récupération entre eux. C’est la durée standard des rounds en boxe professionnelle depuis plus d’un siècle.`)
};

const it_timer_u3m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tre minuti sono abbastanza da richiedere una vera condizione fisica e costringere i pugili a gestire il ritmo, ma abbastanza brevi da permettere più round con tempo di recupero tra uno e l'altro. È la durata standard dei round nella boxe professionistica da oltre un secolo.`)
};

const pt_br2_timer_u3m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Três minutos são longos o suficiente para exigir condicionamento real e forçar os lutadores a administrar o ritmo, mas curtos o suficiente para permitir vários rounds com tempo de recuperação entre eles. É a duração padrão de round no boxe profissional há mais de um século.`)
};

const pt_timer_u3m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Três minutos são suficientes para exigir uma condição física real e obrigar os pugilistas a gerir o ritmo, mas suficientemente curtos para permitir vários assaltos com tempo de recuperação entre eles. É a duração padrão de assalto no boxe profissional há mais de um século.`)
};

const ja_timer_u3m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3分は本格的な体力を要求し、選手にペース配分を強いるのに十分な長さでありながら、ラウンド間に回復時間を挟んで複数ラウンドを行えるほど短い長さです。プロボクシングでは100年以上にわたり標準的なラウンドの長さとされています。`)
};

const zh_timer_u3m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`三分钟足够考验真正的体能，迫使拳手合理分配体力，同时又足够短，可以安排多个回合并在中间留出恢复时间。一个多世纪以来，这一直是职业拳击的标准回合时长。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u3m_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u3m_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u3m_faq4_a", locale)
	if (locale === "en") return en_timer_u3m_faq4_a(inputs)
	if (locale === "es") return es_timer_u3m_faq4_a(inputs)
	if (locale === "de") return de_timer_u3m_faq4_a(inputs)
	if (locale === "nl") return nl_timer_u3m_faq4_a(inputs)
	if (locale === "fr") return fr_timer_u3m_faq4_a(inputs)
	if (locale === "it") return it_timer_u3m_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u3m_faq4_a(inputs)
	if (locale === "pt") return pt_timer_u3m_faq4_a(inputs)
	if (locale === "ja") return ja_timer_u3m_faq4_a(inputs)
	return zh_timer_u3m_faq4_a(inputs)
};